// extracted by mini-css-extract-plugin
module.exports = {"toaster":"Toaster_toaster__1iM_I","success":"Toaster_success__2fX-j","failure":"Toaster_failure__16c3V"};